import React from 'react';
import Spinner from './Spinner';

const ResultLoader = ({ score, innerRef, resultsPageSlug, totalQuestions, entrySlug }) => {
  // Redirect to results page, putting the answers in the URL
  window.location.replace(
    `${process.env.REACT_APP_OUTPUT_DOMAIN}/quiz-results/${resultsPageSlug}?score=${JSON.stringify(score)}&possibleScore=${JSON.stringify(totalQuestions)}&quiz=${entrySlug}`
  );

  return (
    // Renders a loading page as it redirects
    <div className="u-absolute u-p-12 u-w-full u-mt-0" ref={innerRef}>
      <h2 className="u-flex u-flex-col u-items-center u-text-orange-500">
        Generating your results…
      </h2>

      <Spinner />

      <div className="u-mt-8 u-text-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          version="1.0"
          viewBox="0 0 128 128"
          className="u-w-24"
        >
          <g>
            <path
              d="M75.4 126.63a11.43 11.43 0 0 1-2.1-22.65 40.9 40.9 0 0 0 30.5-30.6 11.4 11.4 0 1 1 22.27 4.87h.02a63.77 63.77 0 0 1-47.8 48.05v-.02a11.38 11.38 0 0 1-2.93.37z"
              fill="#fff"
              fillOpacity="1"
            />
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 64 64"
              to="360 64 64"
              dur="1400ms"
              repeatCount="indefinite"
            />
          </g>
        </svg>
      </div>
    </div>
  );
};

export default ResultLoader;
